export type ReportKind = 'payable' | 'paid' | 'receivable' | 'received';

export interface ReportFilters {
  fromDate: Date;
  toDate: Date;
  accountId?: string | undefined;
  counterpartyId?: string | undefined;
  costCenterId?: string | undefined;
  categoryId?: string | undefined;
}

export const REPORT_LABELS: Record<ReportKind, string> = {
  payable: 'Contas a pagar',
  paid: 'Contas pagas',
  receivable: 'Contas a receber',
  received: 'Contas recebidas',
};

export const REPORT_DESCRIPTIONS: Record<ReportKind, string> = {
  payable: 'Despesas pendentes — o que ainda precisa ser pago no período',
  paid: 'Despesas já liquidadas — o que foi efetivamente pago',
  receivable: 'Receitas pendentes — o que ainda está a receber',
  received: 'Receitas já liquidadas — o que foi efetivamente recebido',
};

export function isReportKind(value: string): value is ReportKind {
  return value === 'payable' || value === 'paid' || value === 'receivable' || value === 'received';
}

interface KindMapping {
  type: 'income' | 'expense';
  status: 'pending' | 'completed';
  /** Campo de data usado no filtro: dueDate para pendentes, paymentDate para pagos. */
  dateField: 'dueDate' | 'paymentDate';
}

export const KIND_MAPPING: Record<ReportKind, KindMapping> = {
  payable: { type: 'expense', status: 'pending', dateField: 'dueDate' },
  paid: { type: 'expense', status: 'completed', dateField: 'paymentDate' },
  receivable: { type: 'income', status: 'pending', dateField: 'dueDate' },
  received: { type: 'income', status: 'completed', dateField: 'paymentDate' },
};
